import zhCN from 'ant-design-vue/es/locale/zh_CN';

export const lang = {
  ...zhCN,
  // 提示
  'ep_admin_tips_input': '请输入',
  'ep_admin_tips_select': '请选择',
  'ep_admin_tips_search': '请搜索',

  // 按钮
  'ep_admin_btns_search': '查询',
  'ep_admin_btns_reset': '重置',
  'ep_admin_btns_unfold': '展开',
  'ep_admin_btns_fold': '收起',
  'ep_admin_btns_Export': '导出',
  ep_admin_btns_ExportList: '导出列表',
  ep_admin_dpp_ExportAgreements: '导出协议',
  ep_admin_dpp_ExportCertificates: '导出证书',
  ep_admin_dpp_exportSelectTip: 'Please select the checklists you want to export first',
  ep_admin_dpp_exportLimitTip: '导出数量超限',
  ep_admin_dpp_exportLimitTipContent: '单次导出不能超过100条，请分批导出。',
  ep_admin_dpp_exportProcessingTip: '正在处理中，下载结果将通过邮件通知。',
  'ep_admin_btns_operation': '操作',
  'ep_admin_cdg_action': '操作',
  'ep_admin_btns_ok': '确定',
  'ep_admin_btns_cancel': '取消',
  'ep_admin_btns_download': '下载',
  'ep_admin_btns_upload': '上传',
  'ep_admin_btns_template': '模板',
  'ep_admin_btns_clone': '克隆',
  'ep_admin_btns_back': '返回',
  ep_admin_btns_confirm: '确定',
  'ep_admin_order_return_download': '订单退回导出',

  'ep_admin_user_emailExists': '该邮箱在eParnter中已经存在，确定仍要继续创建新用户？',
  // 'ep_admin_user_companyExport': '文件已发送到您的邮箱 [{email}]',
  'ep_admin_companyMerge_companyType_installer': "安装商",
  'ep_admin_companyMerge_companyType_systemIntegrator': "系统集成商",
  'ep_admin_companyMerge_companyType_alarmReceivingCenter': "接警中心",
  'ep_admin_companyMerge_companyType_endUser': "终端用户",
  'ep_admin_companyMerge_companyType_ITStaff': "IT人员",
  'ep_admin_companyMerge_companyType_other': "其他",
  'ep_admin_companyMerge_companyType_distributor': "分销商",
  'ep_admin_companyMerge_companyType_reseller': "经销商",
  'ep_admin_companyMerge_companyType_OEM': "原始设备制造商",
  'ep_admin_companyMerge_status_initiateMerger': "发起合并",
  'ep_admin_companyMerge_status_merging': "合并中",
  'ep_admin_companyMerge_status_mergeFailed': "合并失败",
  'ep_admin_companyMerge_status_cancellationOfTheMergedCompany': "注销被合并公司",
  'ep_admin_companyMerge_status_FailedMergedCompany': "注销公司失败",
  'ep_admin_companyMerge_status_success': "成功",
  'ep_admin_companyMerge_status_invalid': "无效",
  'ep_admin_companyMerge_status_mergedCompanyReject': "被合并公司拒绝合并",
  'ep_admin_companyMerge_status_mainCompanyReject': "主公司拒绝合并",
  'ep_admin_companyMerge_status_propertyprocessing': "被合并公司资产处理",
  'ep_admin_companyMerge_status_EPAdminmergestart': "被合并用户同意",
  'ep_admin_companyMerge_status_EPAdminWithdraw': "主动撤销合并",
  ep_admin_points_special_disable_re_submit_tip: '您不能重新提交其他人创建的流程。',
  ep_admin_points_companyKeywords: '公司关键词',
  ep_admin_event_step_title_1: '填写基本信息',
  ep_admin_event_step_title_2: '活动时间',
  ep_admin_event_step_title_3: '报名配置',
  ep_admin_event_step_title_4: '提交/预览',
  ep_admin_event_Session_Time: '场次时间',
  ep_admin_event_Session_Time_Single_Session: '单场次',
  ep_admin_event_Session_Time_Multiple_Session: '多场次',
  ep_admin_event_Session_Time_Multiple_Session_tip: 'App 端 Hik-Partner Pro 版本低于XXXXX，暂不支持多场次显示。',
  ep_admin_event_Multiple_Session_single_tip: '你只添加了一个session，请选择单场次模式。',
  ep_admin_login_select_country_tip: '请选择国家获取对应权限',
  ep_admin_login_select_salesOrgnizes_tip: '请选择销售组织',
  ep_admin_login_Guest_Mode: '随便看看',
  ep_admin_b2b_agent_customer_whitelist_tip: '请输入客户SAP ID，用逗号分隔',
  ep_admin_b2b_agent_channel_link_tip: '请输入机器人对应链接',
  ep_admin_b2b_agent_channel_link_required: 'Hikie B2B Enable开启时，Channel Link为必填',
  ep_admin_b2b_agent_fetch_failed: '获取数据失败',
  ep_admin_b2b_agent_update_success: '更新成功',
  ep_admin_b2b_agent_update_failed: '更新失败，请重试',
  ep_admin_explore_translate: '翻译',
  ep_admin_explore_translating: '翻译中',
  ep_admin_explore_search_language: '搜索语言',

  ep_admin_case_white_modal_not_found_companies: '以下公司未找到：',
  ep_admin_case_white_modal_not_found_users: '以下用户未找到：',
  ep_admin_case_table_title10: '白名单用户 SLA',
  // Column Config
  ep_admin_cdg_column_config: '列配置',
  ep_admin_cdg_show: '显示',
  ep_admin_cdg_hide: '隐藏',
  ep_admin_cdg_search_placeholder: '搜索列',
  ep_admin_cdg_company_list: '公司列表',
  ep_admin_cdg_company_column_config: '公司列表列配置',
  // 积分任务配置
  ep_admin_points_New_Points_Task_Configure: '考试和培训类型配置',
  ep_admin_points_458_at_least_one: '请至少选择考试类型或培训类型中的一个选项',
  ep_admin_points_458_exam_type_required: '请至少选择一个考试类型',
  ep_admin_points_458_elearning_type_required: '请至少选择一个培训类型',
  ep_admin_points_458_online_exam_required: '请至少选择一个考试形式（线上考试或线下考试）',
  ep_admin_points_458_certification_required: '请至少选择一个 eLearning 类型（认证或非认证）',
  ep_admin_points_456_Configure: '首页积分入口配置',
  ep_admin_points_457_Configure: '抽奖配置',
  ep_admin_points_459_Configure: '会员计算配置',
  ep_admin_medal_pushNotification_content: '系统会自动向符合条件的客户发送徽章消息。您确定要再次提醒客户吗？',
  ep_admin_designer_device_type: '设备类型',
  ep_admin_designer_mounting_method: '安装方式',
  ep_admin_designer_function_description: '功能描述',
  ep_admin_designer_application_scenario: '应用场景',
  ep_admin_designer_rf_frequency: 'RF 频率',
  ep_admin_designer_transmit_power_R3: "发射功率(R3)",
  ep_admin_designer_transmit_power_Rx: "发射功率(Rx)",
  ep_admin_designer_receiver_gain: '接收增益',
  ep_admin_designer_horizontal_field_of_view: '水平视场角',
  ep_admin_designer_vertical_field_of_view: '垂直视场角',
  ep_admin_designer_horizontal_pir_detection_angle: '水平 PIR 检测角度',
  ep_admin_designer_vertical_pir_detection_angle: '垂直 PIR 检测角度',
  ep_admin_designer_detection_range: '检测范围',

  // Log Modal
  ep_admin_cdg_log_action: '操作',
  ep_admin_cdg_log_user: '用户',
  ep_admin_cdg_log_date: '日期',

  // Duplicate Processing Confirmations
  ep_admin_cdg_confirm_merge_accounts_title: '确认合并账户',
  ep_admin_cdg_confirm_merge_accounts_content: '这将启动客户账户合并。合并记录可在公司组合中查找。',
  ep_admin_cdg_confirm_merge_crm_title: '确认合并 CRM ID',
  ep_admin_cdg_confirm_merge_crm_content: '选中公司的 CRM 账户 ID（如有）将更新为主要账户并同步到 eSales',
  ep_admin_cdg_confirm_mark_unduplicate_title: '确认标记为非重复',
  ep_admin_cdg_confirm_mark_unduplicate_content: '选中公司将从组合中移除并标记为未重复',
  ep_admin_cdg_unduplicate_success: '标记为非重复成功',
  ep_admin_cdg_confirm_detach_title: '确认移除公司',
  ep_admin_cdg_confirm_detach_content: '确定要将"{companyName}"从组合中移除吗？',
  ep_admin_cdg_load_company_list_failed: '加载公司列表失败',
  ep_admin_cdg_load_data_failed: '加载数据失败',
  ep_admin_cdg_merge_failed: '合并失败',
  ep_admin_cdg_update_crm_failed: '更新CRM Account ID失败',
  ep_admin_cdg_mark_unduplicate_failed: '标记非重复失败',
  ep_admin_cdg_detach_failed: '移出公司失败',
  ep_admin_cdg_merge_success: '合并成功',
  ep_admin_cdg_update_crm_success: '更新CRM Account ID成功',
  ep_admin_cdg_detach_success: '移出公司成功',
  ep_admin_cdg_tips_select_primary: '请选择主账户',
  'ep_admin_ranking_Add_Device': '添加设备榜单',
  'ep_admin_ranking_Invitation': '拉新榜单',
  'ep_admin_ranking_Ranking_List_Type': '榜单类型',
  ep_admin_cdg_tips_primary_no_crm_id: '主账户没有CRM Account ID',
  ep_admin_cdg_tips_select_company: '请选择公司',
  ep_admin_cdg_tooltip_mark_primary_merge: '这将启动客户账户合并。合并记录可在公司组合中查找。',
  ep_admin_cdg_tooltip_mark_primary_update_crm: '选中公司的 CRM 账户 ID（如有）将更新为主要账户并同步到 eSales',
  ep_admin_cdg_tooltip_mark_unduplicate: '选中公司将从组合中移除并标记为非重复',

  // Gift Management
  ep_admin_gift_Membership_Level_Empty: '价格不能为空。',

  // Batch Change Country

  ep_admin_customer_batchChangeCountry_updateSso: '同步修改用户在SSO中的国家信息',
  ep_admin_customer_batchChangeCountry_uploadWarning: '请先上传文件',
  ep_admin_customer_batchChangeCountry_updateFailed: '更新失败',
  ep_admin_customer_batchChangeCountry_title: '批量修改公司国家',
  ep_admin_customer_company_twoFactorEnabled: '双因子认证',
  ep_admin_customer_company_twoFactorEnabled_enable: '启用双因子认证',
  ep_admin_customer_company_twoFactorEnabled_disable: '禁用双因子认证',
  ep_admin_customer_company_twoFactorEnabled_confirm: '确认{showStatus}？',
  ep_admin_cdg_merge_status_merge: '合并',
  ep_admin_cdg_merge_status_multiple: '多条',
  ep_admin_cdg_active_status: '活跃状态',
  ep_admin_cdg_tax_id: '税务ID',
  // Automated Marketing
  ep_admin_automatedMarketing_campaignName: '营销任务名称',
  ep_admin_automatedMarketing_description: '描述',
  ep_admin_automatedMarketing_creator: '创建人',
  ep_admin_automatedMarketing_status: '状态',
  ep_admin_automatedMarketing_channels: '触达方式',
  ep_admin_automatedMarketing_benefits: '营销抓手',
  ep_admin_automatedMarketing_objective: '营销目标',
  ep_admin_automatedMarketing_pushTime: '推送时间',

  // Campaign channels
  ep_admin_campaign_channels_email: '邮件',
  ep_admin_campaign_channels_message: '站内信',
  ep_admin_campaign_channels_appPush: 'App推送',
  ep_admin_campaign_channels: '渠道',

  // Campaign benefits
  ep_admin_campaign_benefits_points: '积分',
  ep_admin_campaign_benefits_latestContents: '最新内容',
  ep_admin_campaign_benefits_valueAddedService: '增值服务',
  ep_admin_campaign_benefits: '权益',

  // Campaign status
  ep_admin_campaign_status_saved: '已保存',
  ep_admin_campaign_status_toBeApproved: '待审批',
  ep_admin_campaign_status_rejected: '已驳回',
  ep_admin_campaign_status_approved: '已审批',
  ep_admin_campaign_status_notStart: '未开始',
  ep_admin_campaign_status_ongoing: '进行中',
  ep_admin_campaign_status_terminated: '已终止',
  ep_admin_campaign_status_finished: '已结束',

  // Campaign objective
  ep_admin_automatedMarketing_objective_activation: '促活',
  ep_admin_automatedMarketing_objective_activation_tip: '权益将直接发放至客户账户',
  ep_admin_automatedMarketing_objective_authentication: '认证',
  ep_admin_automatedMarketing_objective_authentication_tip: '从推送消息/邮件开始到活动结束+7天内，完成认证的客户可获得权益',
  ep_admin_automatedMarketing_objective_addDevice: '添加设备',
  ep_admin_automatedMarketing_objective_addDevice_tip: '从推送消息/邮件开始到活动结束+7天内，客户首次添加设备可获得奖励',

  // Campaign actions
  ep_admin_campaign_terminate_title: '确定终止此营销任务？',
  ep_admin_campaign_terminate_content: '终止后，系统将不再向客户推送任何邮件或消息。',
  ep_admin_campaign_terminate_confirm: '确认终止',
  ep_admin_campaign_terminate_success: '已成功终止',
  ep_admin_campaign_delete_title: '确定删除此营销任务？',
  ep_admin_campaign_delete_content: '删除后，营销任务及其关联的OA流程将被永久删除。',
  ep_admin_campaign_delete_confirm: '确认删除',
  ep_admin_campaign_delete_success: '已成功删除',

  // Campaign New/Edit Page
  ep_admin_automatedMarketing_pushDate: '推送日期',
  ep_admin_automatedMarketing_timing: '定时',
  ep_admin_campaign_Page2_Title: '内容配置',
  ep_admin_campaign_Page2_SubTitle: '配置营销任务内容设置',
  ep_admin_btns_return_to_list: '返回列表',
  ep_admin_event_Preview_List: '预览客户列表',
  ep_admin_campaign_setCustomers: '设置客户',
  ep_admin_automatedMarketing_pointsValue: '积分值',
  ep_admin_automatedMarketing_valueAddedService: '增值服务',
  // Freeze/Pre Freeze
  ep_admin_cdg_company_keyword: 'Company Key Word',
  ep_admin_cdg_company_keyword_placeholder: 'Company ID/Company Name/Company Email/CRM account id/CRM Partner No./SAP ID',
  ep_admin_cdg_bu: 'BU',
  ep_admin_cdg_sub_bu: 'Sub BU',
  ep_admin_cdg_country: 'Country',
  ep_admin_cdg_active_status_0: 'Active',
  ep_admin_cdg_active_status_1: 'Prefreeze',
  ep_admin_cdg_active_status_2: 'Manual freeze',
  ep_admin_cdg_active_status_3: 'System freeze',
  ep_admin_cdg_email_sent: 'Email Sent',
  ep_admin_cdg_appeal: 'Appeal',
  ep_admin_cdg_appeal_status_0: '-',
  ep_admin_cdg_appeal_status_1: 'New',
  ep_admin_cdg_appeal_status_2: 'Solved',
  ep_admin_cdg_appeal_status_3: 'Rejected',
  ep_admin_cdg_btn_unlock: 'Unlock',
  ep_admin_cdg_btn_lock: 'Lock',
  ep_admin_cdg_btn_log: 'Log',
  ep_admin_cdg_tooltip_unlock: '支持批量多选解冻：仅支持针对Active status为Freeze的',
  ep_admin_cdg_tooltip_lock: '支持批量多选冻结：仅针对Active status为Prefreeze或者Active的',
  ep_admin_cdg_hpc_company_id: 'HPC Company ID (Short)',
  ep_admin_cdg_ep_company_id: 'EP Company ID',
  ep_admin_cdg_company_name: 'Company Name',
  ep_admin_cdg_company_type: 'Company Type',
  ep_admin_cdg_authorized_status: 'Authorized Status',
  ep_admin_cdg_state: 'State',
  ep_admin_cdg_city: 'City',
  ep_admin_cdg_address: 'Address',
  ep_admin_cdg_crm_account_id: 'CRM Account ID',
  ep_admin_cdg_sap_id: 'SAP ID',
  ep_admin_cdg_company_email: 'Company Email',
  ep_admin_cdg_latest_email_sent_time: 'Latest Email Sent Time',
  ep_admin_cdg_log_title: '操作日志',
  ep_admin_cdg_log_operator: '操作人',
  ep_admin_cdg_lock_reason_title: '冻结原因',
  ep_admin_cdg_lock_reason_label: '人工冻结原因',
  ep_admin_cdg_lock_reason_placeholder: '请输入人工冻结原因',
  ep_admin_cdg_lock_reason_required: '请输入冻结原因',
  ep_admin_cdg_tips_select_records: '请选择要操作的记录',

  // Company Log Modal
  ep_admin_cdg_company_log_title: 'Company Log',
  ep_admin_cdg_changed_type: 'Changed Type',
  ep_admin_cdg_changed_by: 'Changed By',
  ep_admin_cdg_changed_at: 'Changed At',
  ep_admin_cdg_details: 'Details',

  // Appeal Modal
  ep_admin_cdg_appeal_detail_title: 'Appeal Detail',
  ep_admin_cdg_appeal_date: 'Appeal Date',
  ep_admin_cdg_contact_email: 'Contact Email',
  ep_admin_cdg_appeal_reason: 'Appeal Reason',
  ep_admin_cdg_latest_lock_reason: 'Latest Lock Reason',
  ep_admin_cdg_btn_appeal_detail: 'Appeal',
  ep_admin_cdg_btn_reject: 'Reject',
  ep_admin_cdg_appeal_unlock_success: 'Appeal unlocked successfully',
  ep_admin_cdg_appeal_reject_success: 'Appeal rejected successfully',
  ep_admin_cdg_tips_unlock_only_freeze: '仅支持对Active Status为Freeze的记录进行解冻',
  ep_admin_cdg_tips_lock_only_prefreeze_or_active: '仅支持对Active Status为Prefreeze或Active的记录进行冻结',
  ep_admin_cdg_unlock_success: '解冻成功',
  ep_admin_cdg_unlock_failed: '解冻失败',
  ep_admin_cdg_lock_success: '冻结成功',
  ep_admin_cdg_lock_failed: '冻结失败',
  ep_admin_cdg_btn_batch_upload: 'Batch Import',
  ep_admin_cdg_tooltip_batch_upload: 'Support lock or unlock companies in batch. The companies being locked by this way can only appeal to unlock.',
  ep_admin_cdg_download_template: '下载模板',
  ep_admin_cdg_batch_upload_success: '批量上传成功',
  ep_admin_cdg_batch_upload_failed: '批量上传失败',
  ep_admin_cdg_group_id: 'Group ID',
  ep_admin_cdg_primary: 'Primary',
  ep_admin_cdg_detach: '移出',
  ep_admin_cdg_btn_detach: '移出',
  ep_admin_cdg_tips_detach_confirm: '确定要将 "{companyName}" 从组合中移除吗？',
  ep_admin_cdg_tips_detach_success: '移出成功',
  ep_admin_cdg_tips_detach_failed: '移出失败',

  // Survey Share Modal
  ep_admin_survey_share_title: '分享',
  ep_admin_survey_share_portal_link: 'Portal Link',
  ep_admin_survey_share_h5_link: 'H5 链接',
  ep_admin_survey_share_app_link: 'App 链接',
  ep_admin_cdg_remark: 'Remark',
  // HiContent Material Selector
  ep_admin_hicontent_title_select_image: '选择 HiContent 图片',
  ep_admin_hicontent_title_select_video: '选择 HiContent 视频',
  ep_admin_hicontent_title_select_material: '选择 HiContent 素材',
  ep_admin_hicontent_title_select_pdf: '选择 HiContent PDF',
  ep_admin_hicontent_label_material_name: '素材名称',
  ep_admin_hicontent_label_format: '格式',
  ep_admin_hicontent_label_tag: '标签',
  ep_admin_hicontent_label_language: '语言',
  ep_admin_hicontent_no_materials_found: '未找到素材',
  ep_admin_hicontent_selected_count: '已选择：{count} 项',
  ep_admin_hicontent_selected_single: '已选择：1 项',
  ep_admin_hicontent_title_crop_image: '裁剪图片',
  ep_admin_hicontent_message_upload_success: '图片上传成功！',
  ep_admin_hicontent_message_upload_failed: '上传失败',
  ep_admin_hicontent_message_crop_upload_failed: '裁剪并上传图片失败',
  ep_admin_hicontent_message_s3_transfer_failed: '传输到 S3 失败',
  ep_admin_hicontent_message_size_limit: '图片大小不能超过 {maxSize}KB',

  // ImageCropperModal
  ep_admin_imagecropper_title: '裁剪图片',
  ep_admin_imagecropper_not_initialized: '裁剪器未初始化',
  ep_admin_imagecropper_failed: '裁剪图片失败',

  // 内容管理 - 通用
  ep_admin_explore_synced_to: '同步到',
  ep_admin_explore_video_description: '视频描述',
  ep_admin_explore_video_desc_unsupported: '视频描述中不支持图片和 Excel。',
  ep_admin_explore_select_video: '选择视频',
  ep_admin_explore_change_video: '更换视频',
  ep_admin_explore_delete: '删除',
  ep_admin_explore_no_translate_content: '无可翻译内容',
  ep_admin_explore_translation_completed: '翻译完成',
  ep_admin_explore_translation_failed: '翻译失败',

  // HiContent Tab (TinyMCE 富文本编辑器)
  ep_admin_hicontent_tab: 'HiContent',
  ep_admin_explore_hicontent_formats: '支持的格式：JPG, PNG, JPEG, WebP',

  // Banner 管理
  ep_admin_banner_select_publish_to: '请先选择发布位置',
  ep_admin_banner_hicontent_select_image: '选择 HiContent 图片',
  ep_admin_banner_hicontent_or_local: '或',
  ep_admin_banner_hicontent_select_from_hicontent: '从 HiContent 选择图片',

  // AWS 请求超时
  ep_admin_tips_aws_timeout: '请求 AWS 超时，请稍后再试',

  // HiContent 通用消息
  ep_admin_hicontent_image_process_failed: '处理图片失败',
  ep_admin_hicontent_image_transfer_failed: '图片转存失败',
  ep_admin_hicontent_no_hicontent_image_selected: '未选择 HiContent 图片',

  // HiContent 裁剪比例
  ep_admin_hicontent_crop_ratio_16_9: '16:9',
  ep_admin_hicontent_crop_ratio_9_16: '9:16',
  ep_admin_hicontent_crop_ratio_4_3: '4:3',
  ep_admin_hicontent_crop_ratio_3_4: '3:4',
  ep_admin_hicontent_crop_ratio_1_1: '1:1',
  ep_admin_hicontent_preview_alt: '预览图片',

  // 内容管理 - HiContent 相关
  ep_admin_explore_select_from_hicontent: '从 HiContent 选择',
  ep_admin_explore_insert_pdf: '插入 PDF',
  ep_admin_explore_local_upload: '本地上传',
  ep_admin_explore_select_hicontent_image: '选择 HiContent 图片',
  ep_admin_explore_select_hicontent_pdf: '选择 HiContent PDF',
  ep_admin_explore_select_hicontent_material: '选择 HiContent 素材',
  ep_admin_explore_hicontent_image: 'HiContent 图片',
  ep_admin_explore_hicontent_video: 'HiContent 视频',

  // 文件大小限制提示
  ep_admin_explore_maximum100k: '图片大小不能超过 500KB',
  ep_admin_community_community_cover_image_maximum: '图片大小不能超过 20MB',

  // Customer Invitation
  ep_admin_customer_invitation_Inviter_Company_Name: '邀请方公司名称',
  ep_admin_customer_invitation_Inviter_HPC_Company_ID_Short: '邀请方HPC公司ID(short)',
  ep_admin_customer_invitation_Inviter_EP_Company_ID: '邀请方EP公司ID',
  ep_admin_customer_invitation_Inviter_User_Email: '邀请方用户邮箱',
  ep_admin_customer_invitation_Invitee_Name: '受邀方名称',
  ep_admin_customer_invitation_Invitee_HPC_Company_ID_Short: '受邀方HPC公司ID(short)',
  ep_admin_customer_invitation_Invitee_EP_Company_ID: '受邀方EP公司ID',
  // Survey Data Filter
  ep_admin_survey_data_filter: '数据筛选',
  ep_admin_membership_level: '会员等级',
  ep_admin_companyMerge_BU: 'BU',
  ep_admin_companyMerge_Sub_BU: 'Sub-BU',
  ep_admin_companyMerge_countryId: '国家',

  // Survey
  ep_admin_form_type8: '矩阵评分',
  ep_admin_survey_average_score: '平均分',
}